import { DataSource, EnvironmentConfig } from './environment.config';

export const environment: EnvironmentConfig = {
  production: false,
  dataSource: DataSource.Firebase,
  firebase: {
    apiKey: 'AIzaSyBtkeWMSDmUa8Dfd-4MpHcYLdsshRuYp20',
    authDomain: 'caja-flow-dev.firebaseapp.com',
    projectId: 'caja-flow-dev',
    storageBucket: 'caja-flow-dev.firebasestorage.app',
    messagingSenderId: '628261325653',
    appId: '1:628261325653:web:5042ce3cae49e1787dfddc',
    measurementId: 'G-Z696CZ06MH',
  },
};
